import envCodes from '@/assets/js/envCodes'

export default {
  // 根据品类code判断时什么品类；返回值：风机-fan；水泵-pump；末端风口-outlet
  judgeCategory(categoryCode) {
    switch (categoryCode) {
      case envCodes.fanCode: return 'fan'
      case envCodes.pumpCode: return 'pump'
      case envCodes.outletCode: return 'outlet'
      case envCodes.VFWaterSupplyCode: return 'VFWaterSupply'
      default: return categoryCode
    }
  },
  /**
   * 过滤品类下的某些属性
   * @param allProperties: 品类下的所有属性
   * @param code: 扩展属性code
   * @param filterValue: 过滤方法
   * @return result[]: 返回值为过滤后的所有属性
   */
  getAllPropertiesByCode(allProperties, code, filterValue) {
    const allProps = allProperties || []
    const ret = []
    allProps.forEach((item) => {
      if (item && item.configItemValues) {
        const configItem = item.configItemValues.find((x) => x.code === code && filterValue(x.value))
        if (configItem) {
          ret.push(item)
        }
      }
    })
    return ret
  },

  // 处理产品属性数据值,前端以displayType作为最终展示类型的判断
  formatProductPropertiesValue({ allProps, propItem }) {
    if (propItem.displayType === 'Range') {
      return `${propItem.valueFrom} ~ ${propItem.valueTo}`
    } else if (propItem.displayType === 'Enum' && propItem.values && allProps) {
      const propertieyD = allProps.find((a) => a.code === propItem.code)
      if (propertieyD && propertieyD.enumValues) {
        const values = []
        propItem.values.forEach((v) => {
          const enumValue = propertieyD.enumValues.find((ev) => v === ev.code)
          if (enumValue) {
            values.push(enumValue.name)
          }
        })
        return values.join('，')
      }
    } else if (propItem.displayType === 'Bool' && propItem.value) {
      return propItem.value === 'true' ? '是' : '否'
    } else {
      return propItem.value
    }
  },

  /**
   * 根据品类处理产品数据中的产品属性数据
   * @param data: 需要处理的原始数据，数组
   * @param category: 品类（fan/pump/...）
   * @param speed: 当品类为风机时，需要区分单双速（SINGLE_SPEED/DOUBLE_SPEED）
   * @return resultObj: 返回值为处理好键值对的对象
   */
  handleProductPropertiesData({ productsData, category, speed, allProps }) {
    const data = productsData || []
    const resultObj = {}
    if (['fan', 'pump'].includes(category)) {
      const pumpKeys = ['fluid', 'head', 'power', 'efficiency', 'npsh', 'speed', 'length', 'width', 'height', 'weight']
      const fanSingleKeys = ['wind', 'pressure', 'power', 'efficiency', 'noise', 'speed', 'length', 'width', 'height', 'weight']
      const fanDoubleKeys = ['windHigh', 'windLow', 'pressureHigh', 'pressureLow', 'powerHigh', 'powerLow', 'efficiencyHigh', 'efficiencyLow', 'noiseHigh', 'noiseLow', 'speedHigh', 'speedLow', 'length', 'width', 'height', 'weight']
      let displayKeys = []
      switch (category) {
        case 'fan': displayKeys = speed === 'DOUBLE_SPEED' ? fanDoubleKeys : fanSingleKeys; break
        case 'pump': displayKeys = pumpKeys; break
      }
      const isFan = category === 'fan'
      displayKeys.forEach((key) => {
        const code = envCodes[key]
        const keyProp = data.find((p) => p.code === code) || {}
        resultObj[key] = this.formatProductPropertiesValue({ allProps, propItem: keyProp })
        // 获取每个属性的偏差率信息：属性key为`${key}DeviationRate`
        const deviationRateKey = `${key}DeviationRate`
        resultObj[deviationRateKey] = keyProp.deviationRate
        // 风机选中时，会存在属性值为范围的情况，此时运行值传参取额定值
        if (isFan) {
          // selectedRuntimeKey 供选中时取准确的运行值
          const selectedRuntimeKey = `${key}SelectedRuntime`
          const valueIsRange = keyProp.type === 'Number' && keyProp.displayType === 'Range'
          resultObj[selectedRuntimeKey] = valueIsRange ? keyProp.ratedValue : resultObj[key]
        }
      })
    } else {
      // 基础选型处理产品属性值
      productsData.forEach((item) => {
        const key = item.code
        resultObj[key] = this.formatProductPropertiesValue({ allProps, propItem: item })
      })
    }
    return resultObj
  },

  /**
   * 处理设计点和运行点展示的相关数据，暂时与品类无关，可解耦
   * @param data: 需要处理的原始数据，数组[{codes: "P000108", name: "设计流量",type: 'design',unit: "m³/h", values: null}] // propertyKey是唯一标识
   * @param category: 品类，针对风机/水泵，需要做特殊处理
   * @return resultObj: 返回值为处理好键值对的对象
   */
  handleProductDesignOrRuntimeData(data, category) {
    data = data || []
    const resultObj = {}
    data.forEach((item) => {
      const propertyKey = ['fan', 'pump'].includes(category) ? item.name : `${item.type}_${item.codes}`
      resultObj[propertyKey] = item.values
    })
    return resultObj
  },

  /**
   * 处理选中列表的查看详情url的designProps（待废弃）
   * @param row 改行的数据
   * @param category 分类的信息
   * return designProps
   */
  // handleQueryDesignProps(row, category) {
  //   const isSingleSpeed = row.speedControl === 'SINGLE_SPEED'
  //   const isPump = category === 'pump'
  //   const fanPropertyKeys = [
  //     { propertyKey: 'design_air_flow', codeName: 'wind', name: '设计风量', unit: 'm³/h' },
  //     { propertyKey: 'design_total_pressure', codeName: 'pressure', name: '设计全压', unit: 'Pa' }
  //   ]
  //   const pumpPropertyKeys = [
  //     { propertyKey: 'design_pump_flow', codeName: 'fluid', name: '设计流量', unit: 'm³/h' },
  //     { propertyKey: 'design_pump_lift', codeName: 'head', name: '设计扬程', unit: 'm' }
  //   ]
  //   let propertyKeys
  //   switch (category) {
  //     case 'fan': propertyKeys = fanPropertyKeys; break
  //     case 'pump': propertyKeys = pumpPropertyKeys; break
  //   }
  //
  //   return propertyKeys.reduce((acc, prop, index) => {
  //     let codes
  //     if (isSingleSpeed || isPump) {
  //       codes = envCodes[prop.codeName]
  //     } else {
  //       const doubleSpeedCodeHigh = `${prop.codeName}High`
  //       const doubleSpeedCodeLow = `${prop.codeName}Low`
  //       codes = `${envCodes[doubleSpeedCodeHigh]}/${envCodes[doubleSpeedCodeLow]}`
  //     }
  //     acc.push({
  //       codes,
  //       propertyKey: prop.propertyKey,
  //       name: prop.name,
  //       sort: index + 1,
  //       unit: prop.unit,
  //       values: row[prop.propertyKey] || null
  //     })
  //     return acc
  //   }, [])
  // },

  /** 判断产品是单速还是双速
   *  风机产品返回单双速和null
   *  水泵产品返回null
   * */
  getSpeedType(categoryCode, parameters) {
    const type = this.judgeCategory(categoryCode)
    const { electricSpeed, singleSpeed, doubleSpeed } = { ...envCodes }
    if (type === 'fan') {
      if (parameters && parameters.length) {
        const speedProp = parameters.find((p) => p.code === electricSpeed)
        return speedProp.value1 === singleSpeed ? 'SINGLE_SPEED' : speedProp.value1 === doubleSpeed ? 'DOUBLE_SPEED' : null
      }
    } else {
      return null
    }
  },

  /**
   * (已弃用，逻辑改为由后端接口处理)
   * 根据平台，过滤相应的构件资源列表
   * @param data: 数组，需要处理的原始数据
   * @param payload: {platform, softwareCode, softwareVersion}
   * @return array: 返回值为过滤好的构件资源列表
   * **/
  filterComponentsByPlatform(data, payload) {
    if (!data || !data.length) { return [] }
    const { platform, softwareCode, softwareVersion } = payload
    let result = []
    const dataLength = data.length
    if (platform === 'web') {
      result = data
    } else if (platform === 'r') {
      // 兼容老版本插件不含softwareCode和softwareVersion
      if (!softwareCode) {
        result = data.filter((c) => c.softwareCode === 'revit')
      } else {
        for (let i = 0; i < dataLength; i++) {
          const ci = data[i]
          if (softwareCode === ci.softwareCode && ci.softwareVersions.length && ci.softwareVersions[0] <= softwareVersion) {
            result.push(ci)
          }
        }
      }
    } else {
      // G 插件的AppGmep软件
      for (let j = 0; j < dataLength; j++) {
        const cj = data[j]
        if (softwareCode === cj.softwareCode && cj.softwareVersions.length && cj.softwareVersions.some((v) => v === softwareVersion)) {
          result.push(cj)
        }
      }
    }
    return result
  },

  /**
   * 匹配共享参数定义和值，根据名称进行匹配
   * @param definitions：array[]，所有定义
   * @param values：array[]，所有值
   * @return array: 返回已匹配完值的所有定义
   */
  handleShareDefinitionsValue(definitions, values) {
    if (!Array.isArray(definitions) || !Array.isArray(values)) { return [] }
    return definitions.map((item) => {
      const valueItem = values.find((val) => {
        const valStr = val.unit ? `${val.name}(${val.unit})` : val.name
        return valStr === item.name
      })
      return {
        ...item,
        value: valueItem ? valueItem.values : null
      }
    })
  },

}
